import {Component, Injector} from '@angular/core';
import {ColumnType, GeneralListComponent} from "../shared/general-list/general-list.component";

@Component({
    selector: 'app-sites',
    templateUrl: '../shared/general-list/general-list.component.html',
    standalone: false
})
export class SitesComponent extends GeneralListComponent {


  constructor(injector: Injector) {
    super(injector);

    this.title = this.service.getTranslation("SITES");

    this.columns = [
      {id: 'name',label: 'Név', type: ColumnType.Simple},
      {id: 'postalCode',label: 'Irányítószám', type: ColumnType.Simple},
      {id: 'city',label: 'Város', type: ColumnType.Simple},
      {id: 'address',label: 'Cím', type: ColumnType.Simple},
      {id: 'modified',label: 'Módosítva', type: ColumnType.Simple},
      {id: 'modifiedBy',label: 'Módosította', type: ColumnType.Simple},
    ];

  }

  fetchItems() {
    this.service.getSites().subscribe((resp:any) => {
      this.handleFetchResponse(resp)
    })
  }

}

